import React, { useEffect, useState } from "react";
import { Page, LoadingMsg } from "components/common";
import { Row, Col, Button, ModalHeader, ModalBody, ModalFooter, Modal } from "reactstrap";
import Dropzone from "react-dropzone";
import {
    FormGroup,
  } from "components/common/Forms";
import { Trans, useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import { LocalForm, Control, Errors, } from "react-redux-form";
import { ApiClient } from "services";
import BackButton from "components/refactoring/BackButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { getOutlineStyle } from "pages/UserList/Edit";
import { ExSpan } from "pages/Xero/Settings/TaxReturnsDetail";
import { useUserContext } from "../../hooks";
import { ColouredLink } from "components/HoverCard";
import ChangePassword from "./ChangePassword";

const colStyle = {
  xs: false,
  md: 4,
  className: "pt-1 pb-1"
}

const lightGrey = {
  style:{backgroundColor: "#fefefe", color: "#32325d"},
  className:"mb-4 border px-4 py-4 mt-2",
  role:"alert"
}

const ZatcaDetails = ({props}) => {

const client = ApiClient()

const history = useHistory()

const { user } = useUserContext();

const {t} = useTranslation()

const [postImage, setPostImage] = useState();

const [sending, setIsSending] = useState(false);

const oldPicture = user?.user_picture || undefined

  function refresh() {
    window.location.reload();
  }

  const formatDate = (dateString) => {
    const options = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };

    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(new Date(dateString));
  
    return formattedDate.replace(/(\d)(st|nd|rd|th)/, (_, digit, suffix) => `${digit}<sup>${suffix}</sup>`) || dateString
  };
  
  const toProfile = () => {
    history.push("/profiles")
  }

  const toChangePass = () => {
    history.push("/change_password")
  }

  const getTimeOfTheDay = () => {
    const now = new Date();
    const hour = now.getHours();
  
    if (hour >= 5 && hour < 12) {
      return "Morning";
    } else if (hour >= 12 && hour < 15) {
      return "Afternoon";
    } else if (hour >= 15 && hour < 20) {
      return "Evening";
    } else {
      return "Night";
    }
  };

  const timeOfTheDay = getTimeOfTheDay();

  const checkSubscriber = user?.role === "Subscriber"

  const handleSave = (values) => {
    setIsSending(true)

    const simplifiedValues = {};

    Object.keys(values).forEach(key => {
      if (values[key] !== user[key]) {
        simplifiedValues[key] = values[key];
      }
    });
    
    if (Object.keys(simplifiedValues).length === 0) {
      NotificationManager.warning("Values Unchanged");
      setIsSending(false)
      return;
    }
    
    client.patch("me/update_me", simplifiedValues)
      .then(response => {
        console.log("Server response:", response.data);
        setIsSending(false)

        NotificationManager.success("User Details Updated Successfully");
        setTimeout(() => {
          refresh()
        }, 1500);
      })
      .catch(error => {
        console.error("Error:", error);
        setIsSending(false)
    
        if (error.response && error.response.data) {
            const errors = error.response.data;
            Object.keys(errors).forEach(field => {
                const fieldName = field.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
                const errorMessage = errors[field].join(", ");
                NotificationManager.error(`${fieldName}: ${errorMessage}`);
            });
        } else {
            NotificationManager.error("An error occurred while saving");
        }
    });    
    
  };

  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
  };

  const onDropAccepted = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result;
      setPostImage(base64);
    };
    reader.readAsDataURL(file);
  };

  const handleClearLogo = () => {
    setPostImage(null);
  };

  return (
    <Page title={t("User Profile")} className="px-3">
      <BackButton />
      {!user ? (
        <LoadingMsg />
      ) : (
        <div>
          <LocalForm
            onSubmit={values => handleSave(values)} 
            initialState={user}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap:10}}>
              {user.accounting && <span><span className="fa fa-check-circle text-success" /> <Trans>Accounting</Trans></span>}
              {user.payroll && <span><span className="fa fa-check-circle text-success" /> <Trans>HR and Payroll</Trans></span>}
              {user.wp_connect && <span><span className="fa fa-check-circle text-success" /> <Trans>WP Connect</Trans></span>}
              <div className="mx-auto"/>
              {checkSubscriber ? <span style={getOutlineStyle('#32325D')}><Trans>{user.role}</Trans></span>
              : <>{user?.groups?.[0]?.name ? 
                    <span style={getOutlineStyle('#5E72E4')}><Trans>{user?.groups?.[0]?.name}</Trans></span> : 
                    <span style={getOutlineStyle('#007BFF')}><Trans>Super User</Trans></span>}
                </>}
              {user.is_active && !user.suspended && <span style={getOutlineStyle('#72B566')}><Trans>User Active</Trans></span>}
              {user.suspended && <span style={getOutlineStyle('#E64848')}><Trans>Suspended</Trans></span>}
            </div>
            <div className="text-center my-3" style={{fontSize: "1.3em"}}>
                <span style={{fontSize: "1.3em"}}>
                <Trans>Good {timeOfTheDay}!</Trans></span>
                <p><Trans>Welcome to your Profile</Trans>
                  <ColouredLink onClick={() => toProfile()}> {user.full_name}</ColouredLink>
                </p>
                {!checkSubscriber ? 
                  <span><Trans>You joined {user.company_name} on {formatDate(user.date_joined)}</Trans></span> 
                  :
                  <span><Trans>Your company, {user.company_name} joined Hesaab on {formatDate(user.date_joined)}</Trans></span>
                }
                {checkSubscriber && user.next_billing_date && <span><Trans>Your next billing date is on </Trans>{formatDate(user.next_billing_date)}</span>}
            </div>
            <FormGroup label={t("User Profile Picture")} model=".user_picture" className="pt-2 pb-2">
              <Dropzone 
                multiple={false}
                className="border border-primary rounded"
                style={{ backgroundColor: '#F4F7FE', cursor:"pointer" }}
                onDropAccepted={onDropAccepted}>
                  <div className="m-2 text-center">
                    {oldPicture || postImage ? (
                      <>
                      <div>
                        <img
                          style={{maxWidth:300}}
                          alt="user_picture"
                          className="img-thumbnail mb-3"
                          src={ postImage || "/api/" + oldPicture}
                        />
                      </div>
                      <span><Trans>Click to update your Profile Picture.</Trans></span></>
                    ) : <span><Trans>Drop an image file here, or click to select a file to upload.</Trans></span>}
                  </div>
              </Dropzone>
              {/*oldPicture && <Button className="mt-1" onClick={handleClearLogo}>Clear</Button>*/}
              <Errors
                model=".user_picture"
                component={(props) => (
                  <p className="form-text small text-danger" {...props} />
                )}
                messages={{
                  invalid: t("This is not a valid image file"),
                }}
              />
              {postImage && <Control.text defaultValue={postImage} model=".user_picture" hidden/>}
            </FormGroup>
            <div {...lightGrey}>
            {checkSubscriber &&
            <Row className="my-4">
            <Col {...colStyle}>
              <ExSpan label="Tax Number" value={user.tax_number}/>
            </Col>
            <Col {...colStyle}>
              <ExSpan label="Billed" value={user.billed}/>
            </Col>
            <Col {...colStyle}>
              <ExSpan label="Email Verfied On" value={formatDate(user.email_verified)}/>
            </Col>
            </Row>
            }
          <Row className="my-4">
          <Col {...colStyle}>
              <ExSpan label="User ID" value={user.id}/>
            </Col>
            <Col {...colStyle}>
              <ExSpan label="Email" value={user.email}/>
            </Col>
            <Col {...colStyle}>
              <ExSpan label="Country" value={user.country}/>
            </Col>
          </Row>
          <Row>
            <Col {...colStyle}>
              <FormGroup label="First Name" model=".first_name">
                <Control.text model=".first_name"  placeholder={t("First Name")}/>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label="Last Name"  model=".last_name">
                <Control.text model=".last_name" placeholder={t("Last Name")}/>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t("Contact Number")} model=".contact_number">
                <Control.text model=".contact_number" placeholder={t("Contact")} />
              </FormGroup>
            </Col>
          </Row>
          </div>
          <div className="tw-flex justify-content-center my-4">
            {!sending ?
              <Button color="primary" className="ml-0"><Trans>Update</Trans></Button>:
              <Button color="primary" className="ml-0" disabled><span className="fa fa-spinner fa-spin"/> <Trans>Updating</Trans></Button>
            }
            <div className="mx-auto" />
            <span><Trans>Looking to <ColouredLink onClick={() => setShowModal(true)}>Change Password</ColouredLink> ?</Trans></span>
          </div>
      </LocalForm>
      <Modal isOpen={showModal} toggle={handleModalClose} contentLabel="Detailed Response">
        <ModalHeader closeButton>Change Password</ModalHeader>
        <ModalBody>
          <ChangePassword {...props} client={client} onClick={handleModalClose}/>
        </ModalBody>
      </Modal>
    </div>
    )}
    </Page>
  );
};

export default ZatcaDetails;
